module.exports = __webpack_public_path__ + "static/media/nisUniLogo.4c16d8ee.png";